import { ONE_SECOND } from '../utils/constants'

const MAX_ATTEMPTS = 10

export const waitForCondition = (condition = () => false, {
  interval = ONE_SECOND,
  maxAttempts = MAX_ATTEMPTS
} = {}) => {
  return new Promise((resolve, reject) => {
    let attempts = 0

    const check = () => {
      if (condition()) {
        resolve(true)
        return
      }

      attempts++
      if (attempts >= maxAttempts) {
        reject(new Error('Failed after maximum retries'))
        return
      }

      setTimeout(check, interval)
    }

    check()
  })
}